import { Analytics } from '@cobliteam/analytics';
import type { AlertHookType } from '@cobliteam/hooks/src/useAlertHooks/types';

/**
 * Segment events for the alert-hook suggestion modal. `Displayed` is emitted by
 * `useTriggerAlertHook` right before opening the modal; the others fire from the modal's button
 * handlers. All events share the `hookType` + `dismissKey` properties so they can be funnelled
 * end-to-end in the experiment dashboard.
 */
interface AlertHookEventProperties {
  hookType: AlertHookType;
  dismissKey: string;
  dontShowAgain?: boolean;
  /** Only on blueprint hooks, whose PRD reads the funnel by alert type. */
  alert_type?: string;
}

const trackExperienceViewed = (props: AlertHookEventProperties) => Analytics.track('Alert Hook Experience Viewed', props);
const trackActivated = (props: AlertHookEventProperties) => Analytics.track('Alert Hook Activated', props);
const trackDismissed = (props: AlertHookEventProperties) => Analytics.track('Alert Hook Dismissed', props);
const trackEditClicked = (props: AlertHookEventProperties) => Analytics.track('Alert Hook Edit Clicked', props);
/** `Alert Rule Saved` of a blueprint hook: the dialog posts `CreateHookAlert` itself, so the BlueprintProvider never sees it. */
const trackRuleSaved = (alertType: string) => Analytics.track('Alert Rule Saved', { rule_type: alertType, is_new: true });

export type { AlertHookEventProperties };
export { trackActivated, trackDismissed, trackEditClicked, trackExperienceViewed, trackRuleSaved };
